export default __webpack_public_path__ + "static/media/Heart.74bcc4f2.svg";